import { render } from "./TheProfessionalExpedientMeasuresList.vue?vue&type=template&id=5e81038b&scoped=true&ts=true"
import script from "./TheProfessionalExpedientMeasuresList.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalExpedientMeasuresList.vue?vue&type=script&lang=ts"

import "./TheProfessionalExpedientMeasuresList.vue?vue&type=style&index=0&id=5e81038b&lang=scss&scoped=true"
import "./TheProfessionalExpedientMeasuresList.vue?vue&type=style&index=1&id=5e81038b&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e81038b"]])

export default __exports__